module.exports = __webpack_public_path__ + "img/S.0e9084b4.svg";